<template>
  <div class="cmp-wrapper">
    <basic-container>
      <el-form :model="formData" inline ref="storeList">
        <!-- <el-form-item label="所在地区">
          <cascader-address
            :showAll="true"
            type="list"
            ref="cascader"
            :provinceId.sync="formData.provinceId"
            :cityId.sync="formData.cityId"
            :areaId.sync="formData.regionId"
          />
        </el-form-item>
        <el-form-item label="门店搜索">
          <select-input
            ref="selectStore"
            :searchList="selectStore"
            @update="(data) => Object.assign(formData, data)"
          ></select-input>
        </el-form-item> -->
        <el-form-item label="审核状态" prop="verifyStatus">
          <static-selector
            ref="verifyStatus"
            :showAll="true"
            :value.sync="formData.verifyStatus"
            type="verifyStatus"
          />
        </el-form-item>
        <!-- <el-form-item label="启用状态" prop="status">
          <static-selector
            ref="storeStatus"
            :showAll="true"
            :value.sync="formData.status"
            type="storeStatus"
          />
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <!-- <el-button icon="el-icon-plus" type="primary" @click="toAdd" style="margin:15px 0">添加门店</el-button> -->
      <el-table v-loading="loading" :data="tableData">
        <el-table-column label="申请单ID" prop="applyId" align="center"></el-table-column>
        <el-table-column label="门店名称" prop="storeName" align="center"></el-table-column>
        <el-table-column label="门店类型" align="center">
          <template slot-scope="scope">
            {{scope.row.classBName}}
            <div v-if="scope.row.classCName.length!== 0" style="display:inline">
              -
              <div
                v-for="(item, index ) in scope.row.classCName"
                :key="item"
                style="display:inline"
              >
                {{item}}
                <span v-if="index+1!== scope.row.classCName.length">/</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="所在地区" align="center">
          <template
            slot-scope="scope"
          >{{`${scope.row.provinceName}-${scope.row.cityName}-${scope.row.regionName}`}}</template>
        </el-table-column>
        <el-table-column label="门店起送价" align="center">
          <template slot-scope="scope">{{scope.row.minimumQuantity}}元</template>
        </el-table-column>
        <el-table-column label="详细地址" prop="address" align="center"></el-table-column>
        <el-table-column label="启用状态" align="center">
          <template slot-scope="scope">{{scope.row.storeStatus.value}}</template>
        </el-table-column>
        <el-table-column label="审核状态" prop="verifyStatus" align="center"></el-table-column>
        <el-table-column label="创建时间" prop="cT" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button class="operateBtn" type="text" @click="toView(scope.row.storeId, scope.row.applyId, '1')">查看</el-button>
            <el-button
              class="operateBtn"
              type="text"
              v-if="scope.row.verifyStatus!== '待审核'"
              @click="toView(scope.row.storeId, scope.row.applyId, '2')"
            >编辑</el-button>
            <!-- <el-button
              class="operateBtn"
              type="text"
              @click="toPersonnel(scope.row.storeId, scope.row.storeName)"
            >人员</el-button> -->
            <!-- <el-button
              class="operateBtn"
              v-if="scope.row.storeStatus.value==='停用'"
              type="text"
              @click="setting(scope.row)"
            >启用</el-button> -->
            <!-- <el-button
              class="operateBtn"
              v-if="scope.row.storeStatus.value==='启用'"
              type="text"
              @click="setting(scope.row)"
            >停用</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="footer">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="formData.page"
          :page-size.sync="formData.size"
          :page-sizes="[20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :total.sync="total"
          background
        ></el-pagination>
      </div>
    </basic-container>
  </div>
</template>
<script>
import { param, getBaseUrl } from "@/framework/utils/tools";
import { mapGetters } from 'vuex'
export default {
  name:'companyAuditList',
  data() {
    return {
      formData: {
        provinceId: "",
        cityId: "",
        regionId: "",
        groupId: "",
        startTime: "",
        endTime: "",
        name: "",
        status: "",
        verifyStatus: "",
        storeId: 0,
        page: 0,
        size: 20,
        source: 2,
        applyType: 1
      },
      total: 0,
      loading: false,
      tableData: [],
      selectStore: [
        {
          key: "name",
          name: "门店名称",
          placeholder: "请输入门店名称"
        },
        {
          key: "storeId",
          name: "门店ID",
          placeholder: "请输入门店ID"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["systemConfig"])
  },
  activated() {
    this.getStoreList();
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      this.formData.page = 1;
      this.getStoreList();
    },
    reset() {
      ["cascader", "selectStore", "verifyStatus", "storeStatus"].forEach(ref =>
        this.$refs[ref].reset()
      );
      this.$refs["storeList"].resetFields();
    },
    async getStoreList() {
      this.loading = true;
      const {
        ret,
        data: { list, total }
      } = await _api.store.getStoreList(this.formData);
      if (ret && list) {
        Object.assign(this, { tableData: list, total });
      }
      this.loading = false;
    },
    handleSizeChange(val) {
      this.formData.page = 1;
      this.getStoreList();
    },
    handleCurrentChange(val) {
      this.getStoreList();
    },
    toView(storeId, applyId, type) {
      this.$router.push({
        path: "/storeManagement/toViewAudit",
        query: {
          storeId: storeId,
          type: type,
          applyId: applyId
        }
      });
    },
    toPersonnel(storeId, storeName) {
      this.$router.push({
        name: "memberList",
        params: {
          storeId,
          storeName
        }
      });
    },
    // async toAdd() {
    //   let isCan = await this.isCan();
    //   if (this.systemConfig && this.systemConfig.managementType && this.systemConfig.managementType.length > 1) {
    //     this.$message({
    //       type: "error",
    //       message: "暂无“客户类型”，请联系销售补充客户类型"
    //     });
    //   } else if(isCan){
    //     this.$router.push("/storeManagement/add/storeMessage");
    //   } else {
    //     this.$message({
    //       type: "warning",
    //       message: "门店添加已达上限，请联系管理员进行咨询"
    //     })
    //   }
    // },
    // async isCan() {
    //   const {ret, data: { isCanCreateStore }} = await _api.store.isCanCreateStoreByGroupId();
    //   if(ret) {
    //     return isCanCreateStore
    //   }
    //   return false;
    // },
    setting(row) {
      var tips =
        row.storeStatus.value === "停用"
          ? "启用后门店将恢复使用，确认启用吗？"
          : "停用会导致门店不可用，确认停用吗？";
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        if (row.storeStatus.value === "停用") {
          this.open(row.storeId);
        } else {
          this.close(row.storeId);
        }
      });
    },
    async open(storeId) {
      const { ret, data } = await _api.store.open({ storeId });
      if (ret && data) {
        this.$message({
          type: "success",
          message: "启用成功"
        });
        this.getStoreList();
      }
    },
    async close(storeId) {
      const { ret, data } = await _api.store.close({ storeId });
      if (ret && data) {
        this.$message({
          type: "success",
          message: "停用成功"
        });
        this.getStoreList();
      }
    }
  }
};
</script>
